import React, { useEffect, useState } from 'react';
import { getFailoverHistory } from '../../../api/api';
import { Table } from '@amzn/awsui-components-react';
import { Broker, QualifiedFailoverEvent } from '@amzn/amazonmq-opsconsole-client';

type Props = {
    broker: Broker,
}

const FailoverHistory : React.FC<Props> = ({broker}) => {

    const [failoverHistory, setFailoverHistory] = useState<QualifiedFailoverEvent[]>([]);
    const [loadingData, setLoadingData] = useState<boolean>(false);

    useEffect(() => {
        getFailoverHistory(broker.id, broker.snapshotId).then(response => {
            setFailoverHistory(response.failoverHistory);
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            setLoadingData(false);
        })
    }, [broker.id, broker.snapshotId]);

    let columnDefinitions = [
        {
            id: "arcUpdateTime",
            header: "ARC Update Time",
            cell: (item: QualifiedFailoverEvent) => item.failoverEvent.arcUpdateTime,
            sortingField: 'arcUpdateTime'
        },
        {
            id: "initiationTime",
            header: "Initiation Time",
            cell: (item: QualifiedFailoverEvent) => item.failoverEvent.initiationTime,
            sortingField: 'initiationTime'
        },
        {
            id: "completionTime",
            header: "Completion Time",
            cell: (item: QualifiedFailoverEvent) => item.failoverEvent.completionTime,
            sortingField: 'completionTime'
        },
        {
            id: "mode",
            header: "Mode",
            cell: (item: QualifiedFailoverEvent) => item.failoverEvent.mode,
            sortingField: 'mode'
        },
        {
            id: "roleAfterFailover",
            header: "Role after Failover",
            cell: (item: QualifiedFailoverEvent) => item.roleAfterFailover,
        }
    ]

    return (
        <div className="infoTable">
            <Table
                items={failoverHistory}
                empty="No data found"
                columnDefinitions={columnDefinitions}
                loading={loadingData}
                sortingColumn={{
                    sortingField: 'initiationTime'
                }}
                sortingDescending={true}
            />
        </div>
    );

}

export default FailoverHistory;
